import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "teamBillerSelector", "teamSummary", "allTopTeamSummary" ]

  connect() {
    this.filterSummaries();
  }

  filterSummaries() {
    const selectedBillerId = this.teamBillerSelectorTarget.value;

    this.teamSummaryTargets.forEach((summary) => summary.style.display = "none");
    if (this.allTopTeamSummaryTarget) {
      this.allTopTeamSummaryTarget.style.display = "none";
    }

    if (selectedBillerId === "all") {
      if (this.allTopTeamSummaryTarget) {
        this.allTopTeamSummaryTarget.style.display = "block";
      }
    } else if (selectedBillerId) {
      const summary = this.teamSummaryTargets.find(
          s => s.dataset.billerId === selectedBillerId
      );
      if (summary) summary.style.display = "block";
    }
  }
}
